<template>
    <div class="dashboard-graficos">
        <!-- Cards de Métricas Principais -->
        <div class="metricas-grid">
            <CardMetrica
                titulo="Total de Projetos"
                :valor="totalProjetos"
                tipo="numero"
                icone="bi bi-folder"
            />
            <!-- <CardMetrica
                titulo="Projetos em Andamento"
                :valor="projetosEmAndamento"
                tipo="numero"
                icone="bi bi-arrow-right-circle"
            /> -->
            <CardMetrica
                titulo="Índice de Performance de Prazo (IPP)"
                :valor="mediaIPP.toFixed(2)"
                subtitulo="Média geral"
                icone="bi bi-speedometer2"
            />
            <CardMetrica
                titulo="Índice de Performance de Custo (IPC)"
                :valor="mediaIPC.toFixed(2)"
                subtitulo="Média geral"
                icone="bi bi-currency-dollar"
            />
            <CardMetrica
                titulo="Conformidade de Prazo"
                :valor="mediaConformidadePrazo"
                tipo="percentual"
                subtitulo="Média geral"
                icone="bi bi-calendar-check"
            />
            <CardMetrica
                titulo="Conformidade de Custo"
                :valor="mediaConformidadeCusto"
                tipo="percentual"
                subtitulo="Média geral"
                icone="bi bi-piggy-bank"
            />
            <CardMetrica
                titulo="Custo Total"
                :valor="custoTotal"
                tipo="moeda"
                icone="bi bi-cash-stack"
            />
            <CardMetrica
                titulo="Tarefas Atrasadas"
                :valor="totalTarefasAtrasadas"
                tipo="numero"
                icone="bi bi-exclamation-triangle"
            />
        </div>

        <!-- Indicadores de Performance -->
        <div class="secao-graficos">
            <h3 class="titulo-secao">Indicadores de Performance</h3>
            <div class="graficos-grid">
                <div class="grafico-full">
                    <GraficoIPP :projetos="projetos" @clicar-projeto="$emit('clicar-projeto', $event)" />
                </div>
                <div class="grafico-full">
                    <GraficoIPC :projetos="projetos" @clicar-projeto="$emit('clicar-projeto', $event)" />
                </div>
            </div>
        </div>

        <!-- Análise de Conformidade -->
        <div class="secao-graficos">
            <h3 class="titulo-secao">Análise de Conformidade</h3>
            <div class="graficos-grid">
                <div class="grafico-large">
                    <GraficoConformidadePrazo :projetos="projetos" @clicar-projeto="$emit('clicar-projeto', $event)" />
                </div>
                <div class="grafico-large">
                    <GraficoStatusPrazoProjetos :projetos="projetos" @clicar-projeto="$emit('clicar-projeto', $event)" />
                </div>
                <div class="grafico-medium">
                    <GraficoCustoPorProjeto :projetos="projetos" @clicar-projeto="$emit('clicar-projeto', $event)" />
                </div>
                <div class="grafico-medium">
                    <GraficoEficienciaHP :projetos="projetos" @clicar-projeto="$emit('clicar-projeto', $event)" />
                </div>
            </div>
        </div>

        <!-- Distribuições -->
        <div class="secao-graficos">
            <h3 class="titulo-secao">Distribuições</h3>
            <div class="graficos-grid">
                <div class="grafico-small">
                    <GraficoStatusProjetosPizza :projetos="projetos" @clicar-projeto="$emit('clicar-projeto', $event)" />
                </div>
                <div class="grafico-small">
                    <GraficoProjetosPorSetor :projetos="projetos" @clicar-projeto="$emit('clicar-projeto', $event)" />
                </div>
                <div class="grafico-small">
                    <GraficoProjetosPorGerente :projetos="projetos" @clicar-projeto="$emit('clicar-projeto', $event)" />
                </div>
            </div>
        </div>

        <!-- Análise de Usuários e Entregas -->
        <div class="secao-graficos">
            <h3 class="titulo-secao">Análise de usuários e pacotes de trabalho</h3>
            <div class="graficos-grid">
                <div class="grafico-large">
                    <GraficoTarefasPorResponsavel :projetos="projetos" @clicar-projeto="$emit('clicar-projeto', $event)" />
                </div>
                <div class="grafico-large">
                    <GraficoEntregasPorCoordenador :projetos="projetos" @clicar-projeto="$emit('clicar-projeto', $event)" />
                </div>
                <div class="grafico-large">
                    <GraficoHPPorResponsavel :projetos="projetos" @clicar-projeto="$emit('clicar-projeto', $event)" />
                </div>
            </div>
        </div>

        <!-- Análise de Riscos e Alertas -->
        <div class="secao-graficos">
            <h3 class="titulo-secao">Análise de Riscos e Alertas</h3>
            <div class="graficos-grid">
                <div class="grafico-medium">
                    <GraficoProjetosAtrasados :projetos="projetos" @clicar-projeto="$emit('clicar-projeto', $event)" />
                </div>
                <div class="grafico-medium">
                    <GraficoTarefasAtrasadasPorProjeto :projetos="projetos" @clicar-projeto="$emit('clicar-projeto', $event)" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CardMetrica from './CardMetrica.vue';
import GraficoIPP from './GraficoIPP.vue';
import GraficoIPC from './GraficoIPC.vue';
import GraficoConformidadePrazo from './GraficoConformidadePrazo.vue';
import GraficoCustoPorProjeto from './GraficoCustoPorProjeto.vue';
import GraficoStatusProjetosPizza from './GraficoStatusProjetosPizza.vue';
import GraficoEficienciaHP from './GraficoEficienciaHP.vue';
import GraficoTarefasPorResponsavel from './GraficoTarefasPorResponsavel.vue';
import GraficoEntregasPorCoordenador from './GraficoEntregasPorCoordenador.vue';
import GraficoProjetosPorSetor from './GraficoProjetosPorSetor.vue';
import GraficoProjetosPorGerente from './GraficoProjetosPorGerente.vue';
import GraficoHPPorResponsavel from './GraficoHPPorResponsavel.vue';
import GraficoProjetosAtrasados from './GraficoProjetosAtrasados.vue';
import GraficoTarefasAtrasadasPorProjeto from './GraficoTarefasAtrasadasPorProjeto.vue';
import GraficoStatusPrazoProjetos from './GraficoStatusPrazoProjetos.vue';

export default {
    name: 'GraficosIndicadoresProjetos',
    components: {
        CardMetrica,
        GraficoIPP,
        GraficoIPC,
        GraficoConformidadePrazo,
        GraficoCustoPorProjeto,
        GraficoStatusProjetosPizza,
        GraficoEficienciaHP,
        GraficoTarefasPorResponsavel,
        GraficoEntregasPorCoordenador,
        GraficoProjetosPorSetor,
        GraficoProjetosPorGerente,
        GraficoHPPorResponsavel,
        GraficoProjetosAtrasados,
        GraficoTarefasAtrasadasPorProjeto,
        GraficoStatusPrazoProjetos
    },
    props: {
        projetos: {
            type: Array,
            default: () => []
        }
    },
    emits: ['clicar-projeto'],
    computed: {
        totalProjetos() {
            return this.projetos.length;
        },
        projetosEmAndamento() {
            return this.projetos.filter(p => p.status && !p.encerrado).length;
        },
        mediaIPP() {
            const projetosComIPP = this.projetos
                .map(p => this.calcularIPP(p))
                .filter(ipp => ipp !== null && ipp !== undefined);
            
            if (projetosComIPP.length === 0) return 0;
            const soma = projetosComIPP.reduce((acc, ipp) => acc + ipp, 0);
            return soma / projetosComIPP.length;
        },
        mediaIPC() {
            const projetosComIPC = this.projetos
                .map(p => this.calcularIPC(p))
                .filter(ipc => ipc !== null && ipc !== undefined);
            
            if (projetosComIPC.length === 0) return 0;
            const soma = projetosComIPC.reduce((acc, ipc) => acc + ipc, 0);
            return soma / projetosComIPC.length;
        },
        mediaConformidadePrazo() {
            const projetosComPrazo = this.projetos.filter(p => {
                const porcentagem = p.estatisticas?.tarefas?.porcentagem_concluidas ?? 0;
                return porcentagem > 0;
            });
            
            if (projetosComPrazo.length === 0) return 0;
            
            const soma = projetosComPrazo.reduce((acc, p) => {
                const porcentagem = p.estatisticas?.tarefas?.porcentagem_concluidas ?? 0;
                return acc + porcentagem;
            }, 0);
            
            return Math.round(soma / projetosComPrazo.length);
        },
        mediaConformidadeCusto() {
            // Conformidade de Custo requer IPC, que por sua vez requer PCM com estimativa_custo
            const projetosComIPC = this.projetos
                .filter(p => {
                    const ipc = this.calcularIPC(p);
                    return ipc !== null && ipc !== undefined;
                });
            
            if (projetosComIPC.length === 0) return 0;
            
            const somaIPC = projetosComIPC.reduce((acc, p) => {
                const ipc = this.calcularIPC(p);
                if (ipc === null || ipc === undefined) return acc;
                // IPC ideal é 1, então 100% de conformidade seria IPC = 1
                // Se IPC <= 1, conformidade é 100%. Se IPC > 1, conformidade é (1 / IPC) * 100
                const conformidade = ipc <= 1 ? 100 : (1 / ipc) * 100;
                return acc + conformidade;
            }, 0);
            
            return Math.round(somaIPC / projetosComIPC.length);
        },
        custoTotal() {
            return this.projetos.reduce((acc, p) => {
                return acc + (parseFloat(p.custo_total) || 0);
            }, 0);
        },
        totalTarefasAtrasadas() {
            return this.projetos.reduce((acc, p) => {
                return acc + (p.estatisticas?.tarefas?.atrasadas ?? 0);
            }, 0);
        }
    },
    methods: {
        calcularIPP(projeto) {
            // IPP requer PCM com dtInicio E dtEstimadaFinal
            if (!projeto.pcm || !projeto.pcm.dtInicio || !projeto.pcm.dtEstimadaFinal) {
                return null;
            }
            
            const porcentagemConcluidas = projeto.estatisticas?.tarefas?.porcentagem_concluidas ?? 0;
            const totalTarefas = projeto.estatisticas?.tarefas?.total ?? 0;
            const percentualConcluido = porcentagemConcluidas / 100;
            
            // Usar datas do PCM (obrigatórias)
            const dtInicio = projeto.pcm.dtInicio;
            const dtEstimadaFinal = projeto.pcm.dtEstimadaFinal;
            
            const hoje = new Date();
            hoje.setHours(0, 0, 0, 0);
            
            let inicio = null;
            let termino = null;
            let diasTotal = 1;
            let diasDecorridos = 0;
            
            if (dtInicio) {
                inicio = new Date(dtInicio);
                inicio.setHours(0, 0, 0, 0);
                if (isNaN(inicio.getTime())) inicio = null;
            }
            
            if (dtEstimadaFinal) {
                termino = new Date(dtEstimadaFinal);
                termino.setHours(23, 59, 59, 999);
                if (isNaN(termino.getTime())) termino = null;
            }
            
            // Como dtInicio e dtEstimadaFinal são obrigatórios, sempre teremos ambos
            if (inicio && termino) {
                diasTotal = Math.max(1, Math.ceil((termino - inicio) / (1000 * 60 * 60 * 24)));
                const dataReferencia = hoje > termino ? termino : hoje;
                diasDecorridos = Math.max(0, Math.ceil((dataReferencia - inicio) / (1000 * 60 * 60 * 24)));
            } else {
                // Se as datas não são válidas, retornar null
                return null;
            }
            
            const percentualTempo = diasTotal > 0 ? (diasDecorridos / diasTotal) : 0.01;
            
            if (diasDecorridos === 0 || percentualTempo < 0.01) {
                if (totalTarefas === 0) return 0;
                if (porcentagemConcluidas === 0) return 0;
                return Math.min(1, percentualConcluido);
            }
            
            if (totalTarefas === 0) {
                if (percentualTempo > 1) return -0.5;
                return 0;
            }
            
            if (porcentagemConcluidas === 0) {
                if (percentualTempo > 1) {
                    return -Math.min(5, percentualTempo - 1);
                }
                return 0;
            }
            
            if (percentualTempo === 0 || percentualTempo < 0.01) {
                return porcentagemConcluidas > 0 ? Math.min(1, percentualConcluido) : 0;
            }
            
            let ipp = percentualConcluido / percentualTempo;
            
            if (percentualTempo > 5) {
                ipp = -Math.min(10, (percentualTempo - 1) / 2);
            }
            
            const ippLimitado = Math.max(-10, Math.min(10, ipp));
            return Math.round(ippLimitado * 100) / 100;
        },
        calcularIPC(projeto) {
            const custoReal = parseFloat(projeto.custo_total || 0);
            const custoPlanejado = parseFloat(projeto.pcm?.estimativa_custo || 0);
            
            if (custoReal === 0) return null;
            if (custoPlanejado === 0) {
                // Se não há custo planejado do PCM, retornar null
                return null;
            }
            
            return Math.round((custoPlanejado / custoReal) * 100) / 100;
        }
    }
};
</script>

<style scoped>
.dashboard-graficos {
    display: flex;
    flex-direction: column;
    gap: 2rem;
}

.metricas-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 1rem;
}

.secao-graficos {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.titulo-secao {
    font-size: 1.25rem;
    font-weight: 600;
    color: var(--cor-fonte, #333);
    margin: 0;
    padding-bottom: 0.5rem;
    border-bottom: 2px solid var(--cor-separador, #ddd);
}

.graficos-grid {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    gap: 1.5rem;
}

.grafico-full {
    grid-column: span 12;
    width: 100%;
}

.grafico-large {
    grid-column: span 12;
    width: 100%;
}

.grafico-medium {
    grid-column: span 6;
    width: 100%;
}

.grafico-small {
    grid-column: span 4;
    width: 100%;
}

@media (max-width: 1200px) {
    .grafico-medium {
        grid-column: span 12;
    }
    .grafico-small {
        grid-column: span 6;
    }
}

@media (max-width: 768px) {
    .grafico-small {
        grid-column: span 12;
    }
}
</style>

